import { useTranslations } from 'next-intl';
import {
  ContentLayout,
  ReviewsPillarPageContent,
} from '@silvertours/common-landingpages-view';
import {
  BenefitsLegacy,
  ContentArticle,
  StageLegacy,
} from '@silvertours/front-features';

import { Body } from '../body';

const ReviewsPillarContent = ({
  content: { article, globalRating, introduction, links, stage },
  ...commonProps
}: ContentLayout<ReviewsPillarPageContent>) => {
  const t = useTranslations('features');
  const translations = t.raw('article' as any);

  return (
    <Body
      variant={{ kind: 'reviewsPillar' }}
      stage={
        <StageLegacy.Stage
          content={stage.content}
          variant={{ kind: 'reviewsPillar' }}
        />
      }
      content={({ containerModule }) => [
        containerModule(
          'usp',
          <BenefitsLegacy.Usp rating={globalRating.content} />,
        ),
        containerModule(
          'introduction-content',
          <ContentArticle
            modules={introduction?.segments ?? []}
            translations={translations}
          />,
          !!introduction?.segments,
        ),
        containerModule(
          'article',
          <ContentArticle
            modules={article.segments}
            translations={translations}
          />,
        ),
        containerModule(
          'linkLists',
          <ContentArticle
            modules={links.content ?? []}
            translations={translations}
          />,
          !!links.content.length,
        ),
      ]}
      {...commonProps}
    />
  );
};
export { ReviewsPillarContent };
